import { Component, input, output, signal, afterNextRender } from '@angular/core';
import { NativeService } from '@core/services/native/native.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';
import { HamburgerMenuAtomComponent } from '../hamburger-menu-atom/hamburger-menu-atom.component';

@Component({
  selector: 'app-back-header-atom',
  templateUrl: './back-header-atom.component.html',
  imports: [ContentBuilderColorPipe, HamburgerMenuAtomComponent],
})
export class BackHeaderAtomComponent {
  text = input<string | undefined>(undefined);
  icon = input<string | undefined>(undefined);
  menu = input(false);
  isProductHeader = input(false);
  textColor = input<IContentBuilderFieldColor>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  backgroundColor = input<IContentBuilderFieldColor>({
    value: '#FFFFFF',
    type: ColorFieldTypesValues.Hex,
  });

  navigationClick = output<Event>();
  openNavigation = output<Event>();

  isNotched = signal(false);

  constructor() {
    afterNextRender(async () => {
      const notched = await NativeService.isNotched();
      this.isNotched.set(notched);

      if (notched) {
        await StatusBar.setStyle({ style: Style.Light });
      }
    });
  }
}
